/* eslint-disable react/destructuring-assignment */
/* eslint-disable complexity */
import React, { useState, useEffect, Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import commons from '../../commons/commons';
import featureAvailability from '../../commons/featureAvailability';
import { usePriceValidator } from '../hooks/packages';
// import OpcionesPago from "./../../commons/ver-financiacion";

const Precio = (props) => {
  const { t } = useTranslation();
  const [priceValidator, priceTotal] = usePriceValidator();
  // const countryId = useSelector((state) => state.applicationState.paisId);

  const { applicationState, packagesDestination, salidas } = props;
  // checking if country tax is apply in application country ID
  const countryTaxApply = featureAvailability.countryFeatureChecker(applicationState.paisId, packagesDestination.country_name, 'countryTax');
  // checking if price include the new country tax
  const countryTaxIsIncluded = commons.checkCountryTax(salidas[0].precios.impuestoPais);

  const titleUrl = props.title.toLowerCase().trim()
    .replace(/[-]/g, ' ')
    .replace(/[%]/g, ' ')
    .replace(/\s/g, '-')
    .replace(/[-][-][-]/g, '-')
    .replace(/[-][-]/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/amp;/g, '');
  const ngrupo = props.salidas[0].hoteles[0] !== undefined ? props.salidas[0].hoteles[0].nroGrupo : null;
  const nroComb = props.nroComb !== undefined || props.nroComb !== null ? props.nroComb : null;
  const urlRefDetail = (`${process.env.RAZZLE_URL_PATH}/details/${titleUrl
  }?t=${props.referencia
  }&h=${props.distribucion
  }&p=${props.proveedorId
  }&i=${props.idProducto
  }&s=${moment(props.salidas[0].fechaSalida, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
  }&m=${props.salidas[0].precios.moneda
  }&d=${props.idDestino
  }&ngrupo=${ngrupo
  }&nroComb=${nroComb
  }&origen=${props.idOrigen}`
  );
  /* TODO: mhz */
  // const distribucion = Commons.obtenerDistribucion();
  // const cantPasajeros = Commons.obtenerCantidadPasajeros(distribucion);
  // const precio = (props.salidas[0].precios.precioNeto + props.salidas[0].precios.impuestos + props.salidas[0].precios.iva) / cantPasajeros;
  function armarInfoAerolinea(transporte) {
    const elemento = '';
    if (transporte.img === 'Aerolineas Argentinas') {
      return (
        <div className='texto-transporte text-sm'>
          {t('packages.travelingBy')}
          {' '}
          <b className='inline-block'>
            {' '}
            {transporte.nombreTransporte}
          </b>
        </div>
      );
    }
    if (transporte.img.length > 3) {
      return (
        <div className='padding-bottom transporte-paquete'>
          <img src={transporte.img} title={transporte.nombreTransporte} alt={transporte.nombreTransporte} className='img-responsive center-block' height='35px' width='85px' />
        </div>
      );
    }
    if (transporte.nombreTransporte.length > 1) {
      return (
        <div className='texto-transporte text-sm'>
          {t('packages.travelingBy')}
          {' '}
          <b className='inline-block'>
            {' '}
            {transporte.nombreTransporte}
          </b>
        </div>
      );
    }
    return elemento;
  }

  function transporteElemento() {
    let img = '';
    let nombreTransporte = '';

    // Valida proveedor Allseasons
    if (props.proveedorId === 3 || props.proveedorId === 1) {
      if (props.salidas[0].transporte.transporteAereo !== null) {
        img = props.salidas[0].transporte.transporteAereo.imagen === null || props.salidas[0].transporte.transporteAereo.imagen === undefined
          ? ''
          : props.salidas[0].transporte.transporteAereo.imagen;
        nombreTransporte = props.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || props.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
          ? ''
          : props.salidas[0].transporte.transporteAereo.nombreLineaAerea;
      }
    } else if (props.salidas[0].transporte.transporteAereo !== null) {
      img = props.salidas[0].transporte.transporteAereo.imagen === null || props.salidas[0].transporte.transporteAereo.imagen === undefined
        ? ''
        : props.salidas[0].transporte.transporteAereo.imagen;
      nombreTransporte = props.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || props.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
        ? ''
        : props.salidas[0].transporte.transporteAereo.nombreLineaAerea;
    }

    const transporte = {
      img,
      nombreTransporte,
    };
    return armarInfoAerolinea(transporte);
  }
  const [priceExist, setPriceExist] = useState([]);
  const PriceBlockConverted = () => {

    return props.salidas[0].conversionPrecios != null && props.salidas[0].conversionPrecios.map((price) => (
      <Fragment>
        {currencyDefault === price.moneda && (
          <div className='precio'>
            <span className='moneda'>
              {price.moneda}
            </span>
            {price.precioNeto }
          </div>
        )}
      </Fragment>
    ));
  };

  useEffect(() => { PriceBlockConverted(); }, []);
  const currencyDefault = applicationState.currency.description;
  const precioDolar = props.salidas[0].precios.precioNetoDolares;

  // price with validated conditions
  const price = priceValidator(
    props.salidas[0].conversionPrecios,
    props.salidas[0].precios,
  );
  // Calculate final Price per pax
  const priceTotalPerPax = priceTotal(
    price,
    props.cantPasajeros,
    true,
  );

  return (
    <div className='row'>
      <div className='panel-precio grid grid-cols-12 gap-4'>
        <div className='col-span-7 md:col-span-12'>
          <div className='row'>
            <div className='precio'>
              <span className='moneda'>
                {price.moneda}
                &nbsp;
              </span>
              {priceTotalPerPax}
            </div>
            {/*
            {
              //conditional for replace convertedCurrency if ==! defaultCurrency
              currencyDefault === props.salidas[0].precios.moneda ? (
                <div className='precio'>
                  <span className='moneda'>
                    {props.salidas[0].precios.moneda}
                  </span>
                  {props.salidas[0].precios.precioNeto + props.salidas[0].precios.impuestos}

                </div>
              ) : PriceBlockConverted()
            } */}
            {/* conditional if not exist converted currency */}
            {/* {props.salidas[0].conversionPrecios !== null && currencyDefault !== props.salidas[0].precios.moneda && props.salidas[0].conversionPrecios.map((price) => (
              <>

                { price.moneda === props.salidas[0].precios.moneda && (
                  <div className='precio'>
                    <span className='moneda'>
                      {props.salidas[0].precios.moneda}
                    </span>
                    {props.salidas[0].precios.precioNeto + props.salidas[0].precios.impuestos}

                  </div>
                )}
              </>
            ))} */}
            <div className='info-precio'>
              {`${t('packages.priceLegend')} ${props.cantPasajeros} ${t('packages.persons')}`}
            </div>
            {currencyDefault === 'USD' && countryTaxIsIncluded
              ? (
                <React.Fragment>
                  <span className='dib included'>impuesto pais no incluido</span>
                </React.Fragment>
              )
              : countryTaxApply && (
                <span className='country-tax text-sm'>
                  {countryTaxIsIncluded
                    ? (
                      <React.Fragment>
                        <span className='dib included'>Incluye&nbsp;</span>
                        <span className='dib included'>30% IMPUESTO PAIS</span>
                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        <span className='dib not-included'>No incluye&nbsp;</span>
                        <span className='dib not-included'>30% IMPUESTO PAIS</span>
                      </React.Fragment>
                    )}
                </span>
              )}
          </div>
        </div>
        <div className='col-span-5 md:col-span-12'>
          <div className='row'>
            <a
              className='btn paquete-detalle inline-block text-center bg-mbr-color-primario'
              href={urlRefDetail}
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('packages.buttonDetail')}
            </a>
            <div className='pago-cuotas-disponible'>
              {/* TODO: mhz mostrar las opciones de pago */}
              {/* <OpcionesPago */}
              {/* id={ props.idProducto } */}
              {/* uniqueId={ props.indice } */}
              {/* appId={ props.appId } */}
              {/* price={ precio } */}
              {/* customText={ ( */}
              {/* <span><i className="fa fa-chevron-down"/> Formas de pago</span> */}
              {/* ) } */}
              {/* /> */}
            </div>
          </div>
          {transporteElemento()}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  applicationState: state.applicationState,
  packagesDestination: state.packages.ciudadDestino,
});

export default connect(mapStateToProps, null)(Precio);
